
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.067 14.133L15.46 8.041c-.883-2.066-2.508-2.15-3.6-.183L10.284 10.7c-.8 1.441-2.292 1.566-3.325.275l-.183-.234C5.7 9.391 4.184 9.558 3.409 11.1l-1.433 2.875c-1.009 2 .45 4.358 2.683 4.358h10.633c2.167 0 3.625-2.208 2.775-4.2zM5.809 6.667a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    